export enum PrescriptionType {
  E_PRESCRIPTION = "ePrescription",
  UPLOADED_BY_USER = "UploadedByUser",
}
